<!-- GeneChoose.vue only for function 3 and 4 (no samplechoose) -->
<template>
    <div>
      <div class="gene-div-description">
            <h2 class="custom-h2"> {{ desc }}</h2>
              <!-- <p> {{desc}} </p> -->
              <div class="gene-container">
            <div class="gene-div">
                <input class = "custom-input" v-model="gene" placeholder="Enter a gene" />
                <button class = "custom-button" @click="submitGene">Submit</button>
            </div>
        </div>
        </div>  
    </div>
    <div class="image-container-gene" >
      <!-- add an download icon-->
      <div id="wrap">
        <a @click="downloadImage" class="btn-slide">
          <span class="circle">
            <i class="fa fa-download"></i>
          </span>
          <span class="title">Download</span>
          <span class="title-hover">Click here</span>
        </a>
      </div>
        <div class="loading-spinner" v-if="loading"></div>
        <img v-else-if="image" :src="image" alt="Gene Image" class="image"/>

    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { backendIP } from '@/config.js'
  export default {
    name: 'GeneChoose',
    props: {
    uniqueId: String, // Add a unique identifier prop
    function_name: String, // Add a unique identifier prop
    description: String,
    },
    data() {
        return {
        image: null,
        loading: false,
        gene: '',
        desc: this.description,
        fileName: null,
        };
    },
    methods: {
        submitGene() {
            if(this.gene == '')
            {
              alert("Please enter a gene name");
              return;
            }
          
      this.loading = true;
      this.image = null;
      // Make a POST request to localhost:8000 with the gene parameter
      axios.post(`${backendIP}/${this.function_name}`, { genechoose: this.gene }, { responseType: 'arraybuffer' })
        .then((response) => {
          // Handle the response, which contains the image data
          // assert response.status == 200;
          this.loading = false;
          console.log(response.headers['content-type'])
          if (response.headers['content-type'] != "image/png") {
            console.error('POST request error', response);
            this.image = require('../assets/fail.png');
            return;
          }
          const imageBase64 = btoa(
            new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          this.image = `data:image/png;base64,${imageBase64}`;
        })
        .catch((error) => {
          // Handle errors, e.g., display an error message
          console.error('POST request error', error);
          // read from local file
          this.loading = false;
        });
    },
    downloadImage(){
        // Use the browser's download functionality, https://stackoverflow.com/a/23797348
        // only can download image when this.image is not null
        if (this.image == null) {
            return;
        }
        const link = document.createElement('a');
        link.href = this.image;
        link.download = 'figure.png';
        link.click();
    }
  },
  };
  </script>

<style>
.gene-div-description{
  margin-bottom: 20px;
}
.gene-container{
    height: 50px;
    width: 80%;
    margin: 0 auto;
    position: relative;
    margin-top: 10px;

  }
  .gene-div{
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

  }

  .image-container-gene{
    height: 500px;
    position: relative;
    border: 2px solid #0099cc;
    border-radius: 20px;
    object-fit: contain;
    text-align: center;
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;
  }
  
  .image-container{
    height: 500px;
    position: relative;
    border: 2px solid #0099cc;
    border-radius: 20px;
    object-fit: contain;
    text-align: center;
    width: 80%;
    margin: 0 auto;
    margin-top: 120px;
  }
  
  .image {
    /* height: 500px; */
    /* max-width: 100%; */
    /* position: relative;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);*/
    max-height: 100%;
    max-width: 100%;
    height: auto;
    width: auto;
  }

</style>
  